module.exports = __webpack_public_path__ + "static/media/photo6@2x.e841ec0a.jpg";